import { render, staticRenderFns } from "./productChanges.vue?vue&type=template&id=00f6a729"
import script from "./productChanges.vue?vue&type=script&lang=js"
export * from "./productChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports